export const getTestIdInitials = (text: string): string => {
  return text
    .split(' ')
    .map(word => word[0])
    .join('')
    .toLowerCase();
};

export const getTabTestId = (type: string) => {
  const initials = type
    .split(' ')
    .map(word => word[0])
    .join('')
    .toLowerCase();

  return `sd-modal-${initials}-tab`;
};

export const getSidebarMenuTestId = (label: string, category:string) => {
  const formatted = label.toLowerCase().replace(/\s+/g, '-');
  return `sd-modal-general-${category}-${formatted}`;
};

export const testIdFormattedLabel = (label: string ) => {
  const formatted = label.toLowerCase().replace(/\s+/g, '-');
  return formatted;
};
